import Pages from '../../../config/Pages';
import { RouteResource } from '../../../core/utils/RouteMixins';
import { permissionEnums } from '../../../core/enums/PermissionEnums';
import Listagem from './propostaIndicadorListagem/PropostaIndicadorListagem';
import Form from './propostaIndicadorForm/PropostaIndicadorForm';

const propostaIndicadorRoutes = RouteResource(
    ['Propostas de Indicadores', 'pi pi-copy'],
    Pages.sei.propostaIndicador.url,
    [Listagem, Form],
    [permissionEnums.PROPOSTA_INDICADOR_VISUALIZAR]
);

export default propostaIndicadorRoutes;
